import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const MesDossiersSearchFormActions = createActionGroup({
  source: 'Mes Dossiers Search Component',
  events: {
    noActions: emptyProps(),
    resetSearchForm: emptyProps(),
    updateSearchForm: props<{ form: any }>(),
    resetDone: props<{ resetDone: boolean }>(),
    updateIsDossiersEligibles: props<{ isDossierEligible: boolean }>(),
    resetForm: emptyProps(),
    updateIsLoading: props<{ isLoading: boolean }>()
  },
});
